import './Sonar.scss';

import { AdminReferenceDebugger } from '@ui/AdminReferenceDebugger';
import { AppIndex } from './Index';
import { FollowerInitializer } from '@ui/FollowerInitializer';
import { GatewayContent } from '../gateway/general';
import { Layout } from 'antd';
import React from 'react';
import { Sidebar } from './sidebar';

import {
	useAction,
	useCurrentCustomer,
	useCurrentUser,
	useFeatureFlags,
	useNotifications,
	useOnMount,
	useOrganizations,
	useSonarSelector,
	useStakeholders,
	useUsers
} from '@hooks';

export const Sonar: React.FC = () => {
	const loadNotifications = useAction(useNotifications.loadAction);

	useOnMount(() => {
		loadNotifications();
	});

	useFeatureFlags();
	useStakeholders();

	const isCurrentCustomerLoaded = Boolean(useCurrentCustomer().id);
	const isCurrentUserLoaded = Boolean(useCurrentUser().id);
	const areAllOrganizationsLoaded = Boolean(useOrganizations()?.length);
	const areAllUsersLoaded = Boolean(useUsers()?.length);

	const areFeaturesLoaded = Boolean(useSonarSelector(useFeatureFlags.selectors.data));
	const areNotificationsLoaded = Boolean(useSonarSelector(useNotifications.selectors.dataExists));

	const isReady =
		isCurrentCustomerLoaded &&
		areFeaturesLoaded &&
		areAllOrganizationsLoaded &&
		areAllUsersLoaded &&
		isCurrentUserLoaded &&
		areNotificationsLoaded;

	if (!isReady) {
		return <GatewayContent />;
	}

	return (
		<>
			<AdminReferenceDebugger />
			<FollowerInitializer />
			<Layout
				hasSider
				id='sonar'>
				<Sidebar />
				<AppIndex />
			</Layout>
		</>
	);
};
